import { gql } from "graphql-request";

const SERVER_CHANGE_ORDER_COMPANY_FEED = gql`
  mutation SERVER_ChangeOrderCompanyFeed($id: ID!, $action: String!) {
  changeOrderCompanyFeed(id: $id, action: $action)
}
`;
export default SERVER_CHANGE_ORDER_COMPANY_FEED;
